var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _setup.promotions.length === 0
        ? _c(
            _setup.FormControlPlainText,
            { attrs: { "form-id": _vm.formId } },
            [_c("em", [_vm._v("No promotions available.")])]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_setup.promotions, function (promotion) {
        return _c("div", { key: promotion.id, staticClass: "radio" }, [
          _c("label", [
            _c("input", {
              attrs: { type: "checkbox" },
              domProps: {
                checked: _setup.categoryIds?.indexOf(promotion.id) > -1,
              },
              on: {
                click: function ($event) {
                  return _setup.toggleSelection(promotion.id)
                },
              },
            }),
            _vm._v("\n            " + _vm._s(promotion.title) + "\n        "),
          ]),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }